import type { ApiInterceptor } from '@app/services/ApiInterceptor'

import { createThunk } from '@app/store/thunk'

export function getApiInterceptor() {
  return createThunk((_dispatch, _getState, context) => context.lookupEnsure<ApiInterceptor>(ApiInterceptorSymbol))
}
export function setApiInterceptor(value: ApiInterceptor) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(ApiInterceptorSymbol, value))
}

const ApiInterceptorSymbol = Symbol('ApiInterceptor')
